import '@fontsource-variable/inter';
import './styles/theme.css';
import './styles/base.css';
import './ui/ui.css';
import './shell/shell.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { installIntlCache } from './core/intlCache';
import { applyTheme } from './core/settings';
import { App } from './shell/App';

installIntlCache();
applyTheme();
// Follow the OS when the theme is "system".
matchMedia('(prefers-color-scheme: light)').addEventListener('change', () => applyTheme());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Web/PWA: keep the app shell cached for instant, offline starts.
if (!__NATIVE__ && 'serviceWorker' in navigator && import.meta.env.PROD) {
  void import('virtual:pwa-register').then(({ registerSW }) => registerSW({ immediate: true }));
}
